import Layout from 'src/layouts/Index.vue';
import Page from 'src/pages/home/Index.vue';
import Error404 from 'src/pages/error/Error404.vue'
import { routes as fullDineInRoutes } from './full_dinein.routers';
/*
 * @property { meta } { header } 头部配置
 * header: {
 *   showHeader: { Boolean }, // 是否显示头部
 *   showBg: { Boolean },     // 是否显示背景
 *   showBack: { Boolean },   // 是否显示返回按钮
 *   showUser: { Boolean },   // 是否显示用户头像
 * }
*/
const routes = [
  {
    path: '/:store',
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        component: Page
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('src/pages/test/Index.vue'),
      },
      {
        path: 'test1',
        name: 'test1',
        component: () => import('src/pages/test/Index.vue'),
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('src/pages/user/Index.vue'),
        children: [
          {
            path: 'order-history',
            name: 'order-history',
            component: () => import('src/pages/user/order/Index.vue'),
            meta: {
              requireAuth: true,
              requireUser: true,
              header: {
                showHeader: true,
                title: 'title.productsList', // i18nkey
                showBg: true,
                showBack: true,
                backLink: 'products-list'
              }
            },
          },
        ],
      },
      {
        path: 'login',
        name: 'login',
        component: () => import('src/pages/login/Login.vue'),
        meta: {
          header: {
            showHeader: true,
            title: 'title.title', // i18nkey
            showBg: true,
            showBack: true
          }
        }
      },
      {
        path: 'products-list',
        name: 'products-list',
        component: () => import('src/pages/list/Index.vue'),
        meta: {
          header: {
            showHeader: true,
            showUser: true,
            showBg: true,
            showBack: true,
            backLink: 'home'
          }
        },
        children: [
          {
            path: 'order-again',
            name: 'order-again',
            component: () => import('src/components/recommend/OrderAgainDialog.vue')
          },
          {
            path: ':id',
            name: 'product-detail',
            component: () => import('src/pages/details/Index.vue')
          }
        ]
      },
      {
        path: 'products/:id',
        name: 'products-detail',
        component: () => import('src/pages/details/Index.vue')
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('src/pages/search/Index.vue'),
        meta: {
          header: {
            showHeader: true,
            showBg: true,
            showUser: true,
          }
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: () => import('src/pages/cart/Index.vue'),
        meta: {
          header: {
            showHeader: true,
            title: 'title.cart', // i18nkey
            showBg: true,
            showBack: true,
            shadow: true,
            backLink: 'products-list'
          }
        }
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: () => import('src/pages/checkout/Index.vue'),
        meta: {
          requireAuth: true,
          header: {
            showHeader: true,
            title: 'title.checkout', // i18nkey
            showBg: true,
            showBack: true,
            shadow: true,
            backLink: 'cart'
          }
        },
      },
      {
        path: 'qris-waiting',
        name: 'qris-waiting',
        component: () => import('src/pages/waiting/qris/index.vue'),
      },
      {
        path: 'ovo-waiting',
        name: 'ovo-waiting',
        component: () => import('src/pages/waiting/ovo/Index.vue'),
      },
      {
        path: 'gopay-waiting',
        name: 'gopay-waiting',
        component: () => import('src/pages/waiting/gopay/Index.vue'),
      },
      {
        path: 'shopee-waiting',
        name: 'shopee-waiting',
        component: () => import('src/pages/waiting/shopee/Index.vue'),
      },
      {
        path: 'dana-waiting',
        name: 'dana-waiting',
        component: () => import('src/pages/waiting/dana/Index.vue'),
      },
      {
        path: 'virtual-account',
        name: 'virtual-account',
        component: () => import('src/pages/waiting/virtual/Index.vue'),
        meta: {
          header: {
            showHeader: true,
            title: 'title.virtual', // i18nkey
            showBg: true,
            showBack: false,
          }
        }
      },
      {
        path: 'result',
        name: 'result',
        component: () => import('src/pages/result/Index.vue'),
        children: [
          {
            path: 'success',
            name: 'success',
            component: () => import('src/pages/result/Success.vue'),
          },
          {
            path: 'waiting',
            name: 'waiting',
            component: () => import('src/pages/result/Success.vue'),
          },
          {
            path: 'accepted',
            name: 'accepted',
            component: () => import('src/pages/result/Accepted.vue'),
          },
          {
            path: 'finished',
            name: 'finished',
            component: () => import('src/pages/result/Finished.vue'),
          },
          {
            path: 'completed',
            name: 'completed',
            component: () => import('src/pages/result/Completed.vue'),
          },
          {
            path: 'canceled',
            name: 'canceled',
            component: () => import('src/pages/result/Canceled.vue'),
          },
        ],
      },
      // Full Dine In Routers
      ...fullDineInRoutes,
      {
        path: '*',
        name: 'page-full-error',
        component: Error404,
      },
    ],
  },
  {
    path: '*',
    name: 'error',
    component: Error404,
  },
]

export default routes;
